import { Platform } from "src/libs/platform";
import { Log } from "src/libs/log";
import { Token } from "src/containers/authentication/models/token";

declare global {
    interface Window {
        MobileLogout: MessagePort;
        MobileBiometrics: MessagePort;
        MobileRefreshToken: MessagePort;
        MobileInAppWebsite: MessagePort;
        flutter_inappwebview: {
            _callHandler: (name: string) => Promise<any>;
        };
    }
}

class MobileUtils {
    static getB2CToken = () => {
        const queryString = window.location.search.substring(1);
        return new URLSearchParams(queryString).get("code");
    };

    static getTokenFromUrl = (encodedToken: string | null): Token | null => {
        const tokenString = new URLSearchParams(window.location.search).get(
            "webtoken"
        );
        if (encodedToken !== null || tokenString !== null) {
            try {
                // Por problemas de inappwebview, no se puede setear
                // cookies en un WebView desde Flutter web; por eso
                // necesitamos enviar el token en base64 desde Flutteer web
                return Token.fromJson<Token>(
                    JSON.parse(
                        window.atob((encodedToken ?? tokenString) as string)
                    )
                );
            } catch (e) {
                Log.error("Error parsing token from URL:", e);
                return null;
            }
        }
        return null;
    };

    static logoutMobile = () => {
        if (Platform.isRunningOnFlutter()) {
            try {
                const postMessageOrigin = window.MobileLogout;
                if (postMessageOrigin) {
                    postMessageOrigin.postMessage("logout");
                }
                if (window.flutter_inappwebview) {
                    window.flutter_inappwebview
                        ._callHandler("MobileLogout")
                        .then(() => {
                            Log.info("Login out...");
                        });
                }
            } catch (e) {
                Log.error("error in WebviewChannel.logout:", e);
            }
        }
    };

    static launchBiometrics = () => {
        if (Platform.isRunningOnFlutter()) {
            try {
                const postMessageOrigin = window.MobileBiometrics;
                postMessageOrigin.postMessage("biometrics");
            } catch (e) {
                Log.error("error in WebviewChannel.biometrics:", e);
            }
        }
    };

    static refreshToken = (token: Token) => {
        if (Platform.isRunningOnFlutter()) {
            try {
                const tokenString = JSON.stringify(token);

                const postMessageOrigin = window.MobileRefreshToken;
                postMessageOrigin.postMessage(tokenString);
            } catch (error) {
                Log.error("Error dispatching MobileRefreshToken event:", error);
            }
        }
    };
}

export { MobileUtils };
